import React from 'react';
import { Box, Grid, Paper, Container, Chip } from '@mui/material';
import { StyledTypography, StyledButton } from '../styles/styles';
import BatteryDefaultImage from '../../../assets/images/batteryscopecinfoimage.jpeg';
import { useNavigate } from 'react-router-dom';

const Info2 = () => {

//   navigate to the submit battery data page
const navigate = useNavigate();

const handleSubmit = () => {
  navigate('/batteryscope-c/visualize');
};

  return (
    <Container maxWidth={false} sx={{ py: 2, height: '90vh', display: 'flex', alignItems: 'center', px: 3 }}>
      <Paper
        elevation={0}
        sx={{
          p: 3,
          background: 'linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #000000 100%)',
          borderRadius: '2rem',
          fontFamily: 'Bai Jamjuree',
          position: 'relative',
          overflow: 'hidden',
          height: '100%',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        {/* Header Section */}
        <Box textAlign="center" mb={2}>
          <StyledTypography
            variant="h5"
            align="center"
            sx={{
              color: '#e8442d',
              fontWeight: 700,
              mb: 1,
            }}
          >
            BatteryScope-C
          </StyledTypography>
          <StyledTypography
            variant="subtitle2"
            align="center"
            sx={{
              color: '#cccccc',
              fontStyle: 'italic',
              letterSpacing: 1,
              fontSize: '0.9rem',
              fontWeight: 400,
              opacity: 0.9,
            }}
          >
            Quick & Comprehensive &nbsp;|&nbsp; Powered by Advanced Spectroscopy
          </StyledTypography>
        </Box>

        {/* Main Content Area */}
        <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, gap: 2, alignItems: 'center' }}>
          {/* Image Section */}
          <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Box
              sx={{
                position: 'relative',
                display: 'inline-block',
                maxHeight: '50vh',
                width: '100%',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: -8,
                  left: -8,
                  right: -8,
                  bottom: -8,
                  background: 'linear-gradient(45deg, #e8442d, #ff6b35, #e8442d)',
                  borderRadius: '12px',
                  zIndex: -1,
                  opacity: 0.3,
                  animation: 'pulse 2s infinite',
                },
                '@keyframes pulse': {
                  '0%': { opacity: 0.3 },
                  '50%': { opacity: 0.6 },
                  '100%': { opacity: 0.3 },
                }
              }}
            >
              <img
                src={BatteryDefaultImage}
                alt="Cell Image"
                style={{
                  width: '100%',
                  maxWidth: '600px',
                  maxHeight: '45vh',
                  display: 'block',
                  margin: '0 auto',
                  objectFit: 'contain',
                  borderRadius: '12px',
                  border: '3px solid #e8442d',
                  background: 'linear-gradient(135deg, #222222, #333333)',
                  boxShadow: '0 8px 32px rgba(232, 68, 45, 0.3)',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'scale(1.02)';
                  e.target.style.boxShadow = '0 12px 40px rgba(232, 68, 45, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'scale(1)';
                  e.target.style.boxShadow = '0 8px 32px rgba(232, 68, 45, 0.3)';
                }}
              />
            </Box>
          </Box>

          {/* Specifications Section */}
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%' }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Box sx={{ mb: 2 }}>
                  <StyledTypography 
                    variant="subtitle2" 
                    sx={{ 
                      color: '#e8442d', 
                      mb: 1,
                      fontWeight: 600,
                      fontSize: '0.85rem',
                      textTransform: 'uppercase',
                      letterSpacing: 0.5,
                    }}
                  >
                    Make / Model
                  </StyledTypography>
                  <Box sx={{ 
                    background: 'linear-gradient(135deg, #222222, #2a2a2a)', 
                    color: 'white', 
                    borderRadius: '12px', 
                    p: 1.5, 
                    mb: 2, 
                    fontWeight: 600,
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      boxShadow: '0 6px 20px rgba(232, 68, 45, 0.2)',
                      border: '1px solid rgba(232, 68, 45, 0.3)',
                    }
                  }}>
                    LG 21700
                  </Box>
                </Box>
                <Box>
                  <StyledTypography 
                    variant="subtitle2" 
                    sx={{ 
                      color: '#e8442d', 
                      mb: 1,
                      fontWeight: 600,
                      fontSize: '0.85rem',
                      textTransform: 'uppercase',
                      letterSpacing: 0.5,
                    }}
                  >
                    Cell Chemistry
                  </StyledTypography>
                  <Box sx={{ 
                    background: 'linear-gradient(135deg, #222222, #2a2a2a)', 
                    color: 'white', 
                    borderRadius: '12px', 
                    p: 1.5, 
                    fontWeight: 600,
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      boxShadow: '0 6px 20px rgba(232, 68, 45, 0.2)',
                      border: '1px solid rgba(232, 68, 45, 0.3)',
                    }
                  }}>
                    NMC / LFP
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ mb: 2 }}>
                  <StyledTypography 
                    variant="subtitle2" 
                    sx={{ 
                      color: '#e8442d', 
                      mb: 1,
                      fontWeight: 600,
                      fontSize: '0.85rem',
                      textTransform: 'uppercase',
                      letterSpacing: 0.5,
                    }}
                  >
                    Specified Capacity
                  </StyledTypography>
                  <Box sx={{ 
                    background: 'linear-gradient(135deg, #222222, #2a2a2a)', 
                    color: 'white', 
                    borderRadius: '12px', 
                    p: 1.5, 
                    mb: 2, 
                    fontWeight: 600,
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      boxShadow: '0 6px 20px rgba(232, 68, 45, 0.2)',
                      border: '1px solid rgba(232, 68, 45, 0.3)',
                    }
                  }}>
                    5 Ah
                  </Box>
                </Box>
                <Box>
                  <StyledTypography 
                    variant="subtitle2" 
                    sx={{ 
                      color: '#e8442d', 
                      mb: 1,
                      fontWeight: 600,
                      fontSize: '0.85rem',
                      textTransform: 'uppercase',
                      letterSpacing: 0.5,
                    }}
                  >
                    Cell Format
                  </StyledTypography>
                  <Box sx={{ 
                    background: 'linear-gradient(135deg, #222222, #2a2a2a)', 
                    color: 'white', 
                    borderRadius: '12px', 
                    p: 1.5, 
                    fontWeight: 600,
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      boxShadow: '0 6px 20px rgba(232, 68, 45, 0.2)',
                      border: '1px solid rgba(232, 68, 45, 0.3)',
                    }
                  }}>
                    Cylindrical / Prismatic
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>

        {/* Call to Action */}
        <Box textAlign="center" mt={2}>
          <StyledButton
            variant="contained"
            sx={{
              background: 'linear-gradient(45deg, #e8442d, #ff6b35)',
              color: 'white',
              fontWeight: 'bold',
              fontSize: '1.1rem',
              px: 4,
              py: 1.5,
              borderRadius: '50px',
              boxShadow: '0 8px 25px rgba(232, 68, 45, 0.4)',
              border: '2px solid transparent',
              backgroundClip: 'padding-box',
              position: 'relative',
              overflow: 'hidden',
              transition: 'all 0.3s ease',
              '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: -100,
                width: '100%',
                height: '100%',
                background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)',
                transition: 'left 0.5s ease',
              },
              '&:hover': {
                transform: 'translateY(-3px)',
                boxShadow: '0 12px 35px rgba(232, 68, 45, 0.6)',
                '&::before': {
                  left: 100,
                }
              },
              '&:active': {
                transform: 'translateY(-1px)',
              }
            }}
            onClick={handleSubmit}
          >
            Fire BatteryScope-C
          </StyledButton>
        </Box>
      </Paper>
    </Container>
  );
};

export default Info2;
